// 产品数据
export const getProduct = async (obj = {}) => {
  // 创建new parameter对象
  const params = new URLSearchParams()
  // 添加参数
  if (obj.limit) params.append('limit', obj.limit)
  if (obj.page) params.append('page', obj.page)
  if (obj.id) params.append('id', obj.id)
  if (obj.sort) params.append('sort', obj.sort)
  if (obj.order) params.append('order', obj.order)
  if (obj.name) params.append('name', obj.name)
  if (obj.name) params.append('query', obj.name)
  if (obj.category_id) params.append('category_id', obj.category_id)
  if (obj.category_url) params.append('category_url', obj.category_url)
  // 将查询参数附加到 URL
  const url = `/products?${params.toString()}`
  return await fetchGet(url)
}

// 分类数据
export const getCategory = async () => {
  return await fetchGet('/categories?sort=position&order=asc')
}

// 分类详情
export const getCategoryDetail = async (id) => {
  return await fetchGet(`/categories/${id}`)
}

// 产品详情
export const getProductDetail = async (id, locale) => {
  return await fetchGet(`/products/${id}/slug?locale=${locale}`)
}

// 加入购物车
export const addCart = async (id, obj) => {
  const url = `/customer/cart/add/${id}`
  return await fetchPost(url, obj, true)
}

// 获取token
export const getToken = async (obj) => {
  return await fetchPost('/customer/guest-token', obj)
}

// 获取产品详情
export const getProductDetailNew = async (id, currency, locale) => {
  const url = `/onebuy/product/detail/${id}?currency=${currency}&locale=${locale}`
  return await fetchGet(url, false, true)
}

// 获取评论
export const getReviews = async (id, page = 0) => {
  const url = `/reviews?product_id=${id}&page=${page}`
  return await fetchGet(url, false, true)
}

// 获取 paypal id
export const getPaypalId = async (id) => {
  return await fetchGet(`/core-config-fields/${id}`)
}

// 获取 购物车信息
export const getCart = async () => {
  return await fetchGet('/customer/cart', true)
}

// 修改购物车
export const updateCart = async (obj) => {
  return await fetchPut(`/customer/cart/update`, obj, true)
}
// 删除购物车
export const deleteCart = async (id) => {
  return await fetchDelete(`/customer/cart/remove/${id}`, {}, true)
}

// 批量添加购物车
export const addCartBatch = async (id, obj) => {
  return await fetchPost(`/customer/cart/batch-add/${id}`, obj, true)
}

// 选择支付方式
export const selectPayment = async (obj) => {
  return await fetchPost('/customer/checkout/save-payment', obj, true)
}

// 保存 订单
export const saveOrder = async (obj) => {
  return await fetchPost('/customer/checkout/save-order', obj, true)
}

// paypal 快捷支付
export const paypalExpress = async (obj = {}) => {
  return await fetchPost('/customer/cart/order_addr_after', obj, true)
}

// 信用卡支付
export const creditCardPay = async (data) => {
  return await fetchPost('/customer/cart/order-add-sync', data, true)
}

// 获取国家
export const getCountry = async (country) => {
  return await fetchGet(`/countries?limit=1000&code=${country}`)
}

// 获取洲 信息
export const getContinent = async (countryCode) => {
  return await fetchGet(`/countries-states?country_code=${countryCode}&pagination=0`)
}

// 获取站点配置
export const getSiteConfig = async (obj) => {
  const url = `/core-configs?_config[]=${obj.config}`
  return await fetchGet(url)
}

// 地址保存
export const saveAddress = async (obj) => {
  return await fetchPost('/customer/checkout/save-address', obj, true)
}

// 运输方式选择
export const selectShipping = async (obj) => {
  return await fetchPost(
    '/customer/checkout/save-address',
    {
      shipping_method: 'flatrate_flatrate',
    },
    true,
  )
}

// 保存支付方式
export const savePayment = async (obj) => {
  return await fetchPost(
    '/customer/checkout/save-payment',
    {
      payment: {
        method: obj,
      },
    },
    true,
  )
}

// 获取cms
export const getCms = async (locale) => {
  return await fetchGet(`/categories/get-cms/${locale}`)
}

// 获取 cms详情
export const getCmsDetail = async (id, locale) => {
  return await fetchGet(`/categories/cms-detail/${id}?locale=${locale}`)
}

// email订阅
export const emailSubscribe = async (obj) => {
  return await fetchPost('/categories/email', obj)
}

// 获取订单详情
export const getOrderDetail = async (id) => {
  return await fetchGet(`/customer/orders/${id}`, true)
}

// 获取模板配置
export const getTemplateConfig = async (id) => {
  return await fetchGet(`/products/get-index/${id}`)
}

// 产品页推荐产品
export const getProductRecommend = async (id) => {
  return await fetchGet(`/products/get-recommend/${id}`)
}

// 获取渠道信息
export const getChannelInfo = async () => {
  return await fetchGet(`/channels/1`)
}

// coupon 验证
export const couponValidate = async (params) => {
  return await fetchPost(`/customer/cart/coupon`, params, true)
}

// coupon 删除
export const couponDelete = async (params) => {
  return await fetchDelete(`/customer/cart/coupon`, params, true)
}

// 支付方式信息获取
export const getPaymentConfig = async () => {
  return await fetchGet(
    `/core-configs?_config[]=sales.payment_methods.airwallex.active&_config[]=sales.payment_methods.paypal_smart_button.active&_config[]=sales.payment_methods.paypal_smart_button.credit_card&clean-cache=1`,
  )
}

// 获取博客分类列表
export const getBlogCategory = async () => {
  return await fetchGet(`/blog/categories`)
}

// 分类详情
export const getBlogCategoryDetail = async (id) => {
  return await fetchGet(`/blog/categories/${id}`)
}

// 获取文章列表
export const getBlogList = async (params) => {
  // params: category_url_key, page, per_page
  return await fetchGet(
    `/blog/articles?category_url_key=${params.category_url_key}&page=${params.page}&per_page=${params.per_page}`,
  )
}

// 获取文章详情
export const getBlogDetail = async (id) => {
  return await fetchGet(`/blog/articles/by-slug/${id}`)
}

// 获取文章推荐
export const getBlogRecommend = async (data) => {
  // params: limit, type, seo_url_key
  const params = new URLSearchParams()

  if (data.limit) params.append('limit', data.limit)
  if (data.type) params.append('type', data.type)
  if (data.seo_url_key) params.append('seo_url_key', data.seo_url_key)

  // 将查询参数附加到 URL
  const url = `/blog/articles-recommend?${params.toString()}`
  return await fetchGet(url)
}

// utm统计
export const utmStatistics = async (obj) => {
  return await fetchPost('/order-utm', obj)
}

// 流量统计
export const trafficStatistics = async (obj) => {
  return await fetchPost('/visit-log', obj)
}
